/**
 * useStageProgramData — reads the bought stage programme (pattern B).
 *
 * `GET /v1/stage-program` answers this screen only: the payload lives here, never in the store. A
 * recomposition answers with the new programme, which `useStageProgramState` holds over this one.
 */
import { stageProgramService } from "../../../../../../data/services/stageProgramService"
import { type ApiStageProgram } from "../../../../adapters/parent/StageProgram/stageProgramAdapter"
import { useApiFetch } from "../../../hooks/useApiFetch"

export function useStageProgramData() {
    const { raw, loading, error, fetch } = useApiFetch<ApiStageProgram | null>({
        service: stageProgramService.getStageProgram,
    })

    return { raw, loading, error, retry: fetch }
}
